document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('.content-clipboard');
    const tooltips = document.querySelectorAll('.tooltip__body-hint-copy');
    const socialBlock = document.querySelector('.content__info-social');
    const url = window.location.protocol + "//" + window.location.host + window.location.pathname;

    const share = document.querySelector('.content__share-button');
    share.addEventListener('click', async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    url
                });
            } catch (err) {
                console.log(err)
            }
        } else {
            if (socialBlock.style.display === 'flex') {
                socialBlock.style.display = 'none'
            } else {
                socialBlock.style.display = 'flex'
            }
        }
    })

    triggers.forEach((item, i) => {
        item.addEventListener('click', () => {
            window.navigator.clipboard.writeText(url);
            tooltips[i].style.display = 'flex';

            setTimeout(() => {
                tooltips[i].style.display = 'none';
            }, 2000)
        })
    })
});